import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { addressListRoutes } from './lib.routes';
import { ReactiveFormsModule } from '@angular/forms';
import { AddressEditorComponent } from './components/address-editor/address-editor.component';
import { AddressListComponent } from './components/address-list/address-list.component';
import { UiModule } from '@hazmatsuite-next/ui';

@NgModule({
  declarations: [AddressListComponent, AddressEditorComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiModule,
    RouterModule.forChild(addressListRoutes)],
})
export class AddressListModule { }
